import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Label from "../../components/Label";
import ErrorMessage from "../../components/ErrorMessage";
import IInputBoxWidgetProps from "./IinputBoxWidget";
import { returnInputHandlers } from "./inputHandlers";
import "../../../assets/sass/widgets/InputBoxWidget.scss";
import { validationCheck, validationCheckemail } from "../../utils/validation";
import {
    valueResolver,
    getPriceCheckDetails,
    checkForReadOnly,
    checkForPriceChanges,
    dateTimeFormatter,
    specialCharacterCheck,
    dropCheck,
} from "../../utils/utils";
import { CurrencyInput } from "../../utils/numberMask";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import * as globalErrorActionCreators from "../../globalStore/actions";
import { fetchAPI } from "../../utils/service";
import { preventSpecialCharacters } from "../../utils/utils";
import endpoints, { endpointTypes } from "../../service";
import ReactGA from "react-ga";

interface IInputBoxWidgetStateProps {
    inputClass?: any;
    localValue?: any;
    error?: any;
    previousValue?: any;
    priceChangd?: any;
}

/**
 * @class InputTextBox
 * @category Widgets
 * @description This component renders input text box field and the types , binding action can be passed as the parameter to this component , validation and errors also has been handled as part of the component
 */
class InputTextBox extends React.Component<IInputBoxWidgetProps, IInputBoxWidgetStateProps> {
    constructor(props) {
        super(props);
        this.state = {
            inputClass: false,
            localValue: "",
            error: { error: false, errorMessage: [] },
            previousValue: this.props.value || "",
        };
        this.onInputBoxChange = this.onInputBoxChange.bind(this);
        this.onBlurCheck = this.onBlurCheck.bind(this);
        this.onInputBoxKeyDown = this.onInputBoxKeyDown.bind(this);
        this.validate = this.validate.bind(this);
        this.fieldClicked = this.fieldClicked.bind(this);
    }

    checkForPrice = (e) => {
        this.props.dynamicFormActions.apiRunningStatus(true);
        const { errorSchema, schema, id } = this.props;
        const { fieldName, priceCheck } = getPriceCheckDetails(errorSchema, schema, id);
        let reqObject;
        const inputValue = schema.type === "integer" ? parseInt(e) : e;
        if (priceCheck && priceCheck.length) {
            for (const i in JSON.parse(priceCheck[0].value)) {
                reqObject = {
                    ...reqObject,
                    [i]: valueResolver(this.props.warrantyData, JSON.parse(priceCheck[0].value)[i].trim()),
                    [fieldName]: inputValue,
                };
            }
        }
        const requestobject = {
            data: reqObject,
            warrantyId: this.props.warrantyId,
        };
        const successCallBackEditCheck = async () => {
            const formLayoutRoute = endpoints[endpointTypes.FORMLAYOUT];
            const editableCheckEndpoint = formLayoutRoute.endpoints.checkEditable(requestobject);
            try {
                const response = await fetchAPI(editableCheckEndpoint);
                return response;
            } catch (err) {
                this.setState({
                    localValue: this.state.previousValue,
                    error: { error: true, errorMessage: [priceCheck[0].message] },
                });
                this.props.dynamicFormActions.apiRunningStatus(false);
                this.props.globalErrorActions.showGlobalError(err);
            }
        };
        return successCallBackEditCheck();
    };

    async onBlurCheck(event) {
        const userInput = event.target.value;
        const { errorSchema, isSubmittedForm, schema, id } = this.props;
        const { family, fieldName, priceCheck, dataValidatorPath } = getPriceCheckDetails(
            errorSchema,
            schema,
            id,
            true
        );
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;

        const isLowSlopeSquareError = this.props.id && this.props.id.includes('addendums_LowSlopeContainer_lowSlopeSquares') === true ?  true : false;
        if(!isLowSlopeSquareError) {
            removeFieldIdFromStore(this.props.id);

        }
        // const { family } = this.props.schema.const;
        // const id = this.props.id.split("_");
        // const fieldName = this.props.id.split("_")[id.length - 1];
        // const dataValidatorPath =
        //     errorSchema &&
        //     errorSchema.length &&
        //     errorSchema.filter((key) =>
        //         key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
        //     );
        // const priceCheck =
        //     dataValidatorPath.length > 0 &&
        //     dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");
        const validationError = validationCheck(userInput, fieldName, family, errorSchema);
        const { addFieldIdToStore } = this.props.dynamicFormActions;
        if (validationError && validationError.error) addFieldIdToStore({ id, msg: validationError.errorMessage });

        if (
            event.target.value &&
            event.target.value !== this.state.previousValue &&
            priceCheck &&
            priceCheck.length > 0 &&
            checkForPriceChanges(schema.const, isSubmittedForm)
        ) {
            const inputValue = event.target.value;
            const x = await this.checkForPrice(inputValue);
            const {
                warrantyInfo,
                warrantyId,
                waiverReceived,
                dynamicFormActions: { submitWarranty },
            } = this.props;
            if (x && x.data && x.data.isPriceChanged) {
                this.props.dynamicFormActions.submitClicked(false);
                this.props.dynamicFormActions.apiRunningStatus(false);
                this.props.dynamicFormActions.navigationClickDetails({});
                this.setState(
                    {
                        error: { error: true, errorMessage: [priceCheck[0].message] },
                        localValue: this.state.previousValue,
                        priceChangd: x.data.isPriceChanged,
                    },
                    () => {
                        this.props.onChange(this.state.localValue);
                    }
                );
            } else if (x && x.data && !x.data.isPriceChanged && this.props.isSubmitClicked) {
                // submit form only if there is no price change
                const handleSubmitError = (data) => {
                    const validationMessage = (data.errors && data.errors.validationMessage) || "";
                    if (validationMessage) {
                        const payload = {
                            errors: data.errors,
                        };
                        this.props.globalErrorActions.showGlobalError({ Message: validationMessage });
                        this.props.dynamicFormActions.fetchFormErrorResponseSuccess(payload);
                    }
                };
                const successCallBack = (data) => {
                    this.props.dynamicFormActions.submitClicked(false);
                    this.props.dynamicFormActions.apiRunningStatus(false);
                    window["AppInsightTrace"].trackTrace(`on submit form click successCallBack`);
                    ReactGA.event({
                        category: "Submit Form",
                        action: `Submit Form: ${data.id}`,
                        label: `Submit Form: ${data.id} : ${dateTimeFormatter(data.saveTime)}`,
                    });
                    handleSubmitError(data);
                };
                const failureCallback = (data) => {
                    let commonErrorMsg = "";
                    const validationMessage = (data.errors && data.errors.validationMessage) || "";
                    if (validationMessage) {
                        handleSubmitError(data);
                    } else if (data && data.response && data.response.data && data.response.data.Message) {
                        commonErrorMsg = data.response.data.Message;
                        window["AppInsightTrace"].trackException(`on submit form click Failure: ${commonErrorMsg} `);
                    } else {
                        const globalErrorMsg = this.props.globalErrorActions.showGlobalError(
                            (data && data.response && data.response.data) || ""
                        );
                        commonErrorMsg = globalErrorMsg.payload.errorMessage;
                        window["AppInsightTrace"].trackException(
                            `on submit form click global Failure: ${commonErrorMsg}`
                        );
                    }
                    ReactGA.event({
                        category: "Error",
                        action: `Error: ${commonErrorMsg}`,
                        label: `Error: ${commonErrorMsg}`,
                    });
                    this.props.dynamicFormActions.submitClicked(false);
                    this.props.dynamicFormActions.apiRunningStatus(false);
                };
                setTimeout(() => {
                    const payload = {
                        payload: {
                            Id: warrantyId,
                            formData: warrantyInfo,
                            WaiverReceived: waiverReceived,
                            successCallBack: successCallBack,
                            failureCallback: failureCallback,
                        },
                    };
                    submitWarranty(payload);
                }, 1000);
            } else if (
                x &&
                x.data &&
                !x.data.isPriceChanged &&
                this.props.clickDetails &&
                this.props.clickDetails.clickId
            ) {
                this.props.dynamicFormActions.apiRunningStatus(false);
                if (document.getElementById(this.props.clickDetails.clickId))
                    document.getElementById(this.props.clickDetails.clickId).click();
            } else {
                this.setState({ previousValue: this.state.localValue });
                this.props.dynamicFormActions.apiRunningStatus(false);
            }
        } else if (
            !event.target.value &&
            !event.target.value !== this.state.previousValue &&
            priceCheck &&
            priceCheck.length > 0 &&
            checkForPriceChanges(schema.const, isSubmittedForm)
        ) {
            this.props.dynamicFormActions.apiRunningStatus(false);
            this.setState(
                {
                    localValue: this.state.previousValue,
                },
                () => {
                    this.props.onChange(this.state.localValue);
                }
            );
        }

        // check only for conditionalReverse field validations
        const conditionalReverse =
            dataValidatorPath &&
            dataValidatorPath.length &&
            dataValidatorPath[0] &&
            dataValidatorPath[0].value &&
            dataValidatorPath[0].value.length &&
            dataValidatorPath[0].value.filter((val) => val.validationType === "conditionalReverse");
        const parseValue = (value) => {
            let dataValidator = [];
            try {
                dataValidator = JSON.parse(value);
            } catch (e) {
                dataValidator = [];
            }
            return dataValidator;
        };
        if (conditionalReverse && conditionalReverse.length) {
            let value = "";
            const dataValidator = parseValue(conditionalReverse[0].value);
            for (let i = 0; i < dataValidator.length; i++) {
                const splitArr = dataValidator[i].node.split("|");
                for (let j = 0; j < splitArr.length; j++) {
                    if (valueResolver(this.props.warrantyInfo, splitArr[j].trim())) {
                        if (valueResolver(this.props.warrantyInfo, splitArr[j].trim()) !== "") {
                            value = value + " " + valueResolver(this.props.warrantyInfo, splitArr[j].trim());
                        }
                    }
                }
                const dependentId = "root_" + dataValidator[i].node.replace(/\./g, "_");
                if (value.trim() === "") {
                    // if dependentNode is not available & currentNode is available
                    this.props.dynamicFormActions.removeFieldIdFromStore(this.props.id);
                    if (userInput) {
                        this.props.dynamicFormActions.addFieldIdToStore({
                            id: dependentId,
                            msg: conditionalReverse[0].messageForDependentNode,
                        });
                        // if dependentNode is not available & currentNode is  not available
                    } else {
                        this.props.dynamicFormActions.removeFieldIdFromStore(dependentId);
                    }
                } else {
                    // On TextInput blur removing errors from redux store if its LowSlopeSquareError is false
                    // For LowSlopeSquareError = true, keeping error in stroe to display if user click outside textbox
                    if ( !isLowSlopeSquareError ) {
                        // if dependentNode is available & currentNode is available
                        this.props.dynamicFormActions.removeFieldIdFromStore(dependentId);
                        if (userInput) {
                            this.props.dynamicFormActions.removeFieldIdFromStore(this.props.id);
                            
                        }
                        // if dependentNode is available & currentNode is not available
                        else {
                            this.props.dynamicFormActions.addFieldIdToStore({
                                id: this.props.id,
                                msg: conditionalReverse[0].message,
                            });
                        }
                    }
                }
            }
        } else if (validationError && validationError.error) {
                this.setState({
                    error: validationCheck(userInput, fieldName, family, errorSchema),
                });
        }
        if (fieldName == "email") {
            let validationEmailError = await validationCheckemail(event.target.value, fieldName, family, errorSchema);
            this.setState({
                error: validationEmailError,
            });
        }
        // check only for conditional field validations
        const conditional =
            dataValidatorPath &&
            dataValidatorPath.length &&
            dataValidatorPath[0] &&
            dataValidatorPath[0].value &&
            dataValidatorPath[0].value.length &&
            dataValidatorPath[0].value.filter((val) => val.validationType === "conditional");
        if (conditional && conditional.length) {
            let value = "";
            const dataValidator = parseValue(conditional[0].value);
            for (let i = 0; i < dataValidator.length; i++) {
                const splitArr = dataValidator[i].node.split("|");
                for (let j = 0; j < splitArr.length; j++) {
                    if (valueResolver(this.props.warrantyInfo, splitArr[j].trim())) {
                        if (valueResolver(this.props.warrantyInfo, splitArr[j].trim()) !== "") {
                            value = value + " " + valueResolver(this.props.warrantyInfo, splitArr[j].trim());
                        }
                    }
                }
                if (value.trim().split(" ").length !== splitArr.length || value.trim() === "") {
                    this.setState({
                        error: validationCheck(userInput, fieldName, family, errorSchema),
                    });
                } else {
                    this.setState({
                        error: { error: false, errorMessage: [] },
                    });
                }
            }
        } else if (validationError && validationError.error) {
            this.setState({
                error: validationCheck(userInput, fieldName, family, errorSchema),
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value != this.props.value) {
            this.onInputBoxChange(this.props.value || this.props.schema.default || "", "", "");
        }
        if (prevProps.schema.const.family !== this.props.schema.const.family) {
            this.setState({
                error: { error: false, errorMessage: [] },
            });
        }
        if (prevState.localValue !== this.state.localValue) {
            this.setState({
                error: { error: false, errorMessage: [] },
            });
        }
    }

    onInputBoxChange(changeValue, element, type) {
        const { value } = element && element.target;
        const { errorSchema, schema, id } = this.props;
        const { family, fieldName, priceCheck } = getPriceCheckDetails(errorSchema, schema, id);
        // const id = this.props.id.split("_");
        // const { family } = this.props.schema.const;
        // const fieldName = this.props.id.split("_")[id.length - 1];
        // const dataValidatorPath =
        //     errorSchema &&
        //     errorSchema.length &&
        //     errorSchema.filter((key) =>
        //         key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
        //     );
        // const priceCheck =
        //     dataValidatorPath.length > 0 &&
        //     dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");
        const OutputValue = changeValue || value || "";
        const validationError = validationCheck(OutputValue, fieldName, family, errorSchema);
        if (validationError && validationError.error) {
            this.setState({
                localValue: OutputValue,
                error: validationCheck(OutputValue, fieldName, family, errorSchema),
            });
        } else {
            this.setState({
                localValue: OutputValue,
                // error: validationCheck(value, fieldName, family, errorSchema),
            });
        }
        if (this.state.priceChangd) {
            this.setState({
                error: { error: true, errorMessage: [priceCheck[0].message] },
            });
        }
        this.props.onChange(OutputValue);
    }

    onInputBoxKeyDown(evt, type) {
        let isNumberValid = false;
        if (type === "number" || type === "integer") {
            if (evt.key === ">") {
                evt.preventDefault();
            }
            if (type === "number") {
                if (evt.key === "." && evt.target.value.split(".").length > 1) evt.preventDefault();
                isNumberValid = /^[.0-9]*$/.test(evt.key);
            } else {
                if (evt.key === ".") evt.preventDefault();
                isNumberValid = /^[0-9]*$/.test(evt.key);
            }
            if (
                !(
                    isNumberValid ||
                    // Allow: backspace, delete, tab, escape, enter and .
                    [46, 8, 9, 27, 13, 110, 190].includes(evt.keyCode) ||
                    // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
                    ((evt.keyCode == 65 || evt.keyCode == 86 || evt.keyCode == 67) &&
                        (evt.ctrlKey === true || evt.metaKey === true)) ||
                    // Allow: home, end, left, right, down, up
                    (evt.keyCode >= 35 && evt.keyCode <= 40)
                )
            ) {
                evt.preventDefault();
            }
        } else if (type === "string") {
            preventSpecialCharacters(evt);
        }
    }

    validate(e, type) {
        if (type === "number") {
            const t = e.target.value;
            const intergerValue = t.split(".")[0];
            const decimalValue = t.split(".")[1];
            const maxIntergerValue = this.props.schema.const.maximum.toString().split(".")[0];
            const maxDecimalValue = this.props.schema.const.maximum.toString().split(".")[1];
            let parsedValue = e.target.value;
            try {
                parsedValue = e.target.value && parseFloat(e.target.value).toFixed(2);
            } catch (e) {
                parsedValue = e.target.value;
            }
            if (parsedValue === "NaN") {
                e.preventDefault();
                e.target.value = this.props.value || this.state.localValue;
                return false;
            }
            if (parsedValue === "0.00") {
                e.preventDefault();
                e.target.value = this.props.value || this.state.localValue;
                return false;
            }
            if (intergerValue.length > maxIntergerValue.length) {
                e.preventDefault();
                e.target.value = this.props.value;
                return false;
            }
            if (decimalValue && decimalValue.length > maxDecimalValue.length) {
                e.preventDefault();
                e.target.value = this.props.value;
                return false;
            }
            const maxStr = this.props.schema.const.maximum.toString();
            if (t.indexOf(".") >= 0) {
                if (t.length >= maxStr.length && parseInt(t) <= this.props.schema.const.maximum) {
                    e.target.value = t.substr(0, maxStr.length);
                } else {
                    e.target.value = t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3);
                }
            } else {
                if (t.length >= maxStr.substr(0, maxStr.indexOf(".")).length) {
                    e.target.value = t.substr(0, maxStr.indexOf("."));
                } else e.target.value = t;
            }
        } else if (type === "integer") {
            const intergerValue = e.target.value;
            const maxIntergerValue = this.props.schema.const.maximum.toString();
            if (e.target.value.charAt(0) === "0") {
                e.preventDefault();
                e.target.value = this.props.value || this.state.localValue;
                return false;
            }
            if (intergerValue.length > maxIntergerValue.length) {
                e.preventDefault();
                e.target.value = this.props.value;
                return false;
            }
            if (e.target.max && parseInt(intergerValue) > parseInt(e.target.max)) {
                e.target.value = intergerValue.substr(0, intergerValue.length - 1);
            }
        }
    }

    fieldClicked = () => {
        // const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        // removeFieldIdFromStore(this.props.id);
    };

    render() {
        const { value, type, schema, id, isSubmittedForm, errorDetails, errorSchema } = this.props;
        const { localValue, error } = this.state;
        const textValue = localValue || value || "";
        const additionalProps = returnInputHandlers(type, schema);
        const { family, fieldName } = getPriceCheckDetails(errorSchema, schema, id);
        return (
            <React.Fragment>
                <Label schema={schema} />
                <div
                    className={
                        (this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0) ||
                            (this.props.errorDetails[id] && this.props.errorDetails[id].length > 0)
                            ? "error-boundry"
                            : "inputbox-rectangle"
                    }
                >
                    {schema.type != "number" && schema.type != "integer" && type != "number" && (
                        <input
                            onFocus={this.fieldClicked}
                            onBlur={(e) => this.onBlurCheck(e)}
                            onChange={(e) => this.onInputBoxChange("", e, schema.type)}
                            onKeyDown={(evt) => this.onInputBoxKeyDown(evt, schema.type)}
                            onKeyUp={(evt) => this.onInputBoxKeyDown(evt, schema.type)}
                            value={type == "number" ? (textValue === "undefined" ? "" : textValue) : textValue}
                            tabIndex={schema.const.tabIndex}
                            className="gaf-inputBox"
                            id={id}
                            type={type == "number" || type == "integer" ? "text" : type}
                            placeholder={schema.const && schema.const.placeholder && schema.const.placeholder}
                            // pattern="[0-9]"
                            // onKeyPress={e => { type === 'number' ? this.handleKeyPress(e, schema.type) : null }}
                            {...additionalProps}
                            onInput={(e) => this.validate(e, schema.type)}
                            autoComplete="off"
                            disabled={checkForReadOnly(schema.const, isSubmittedForm)}
                            onPaste={(e) =>
                                specialCharacterCheck(
                                    e,
                                    { value: e.target["value"], fieldName, family, errorSchema },
                                    schema.type
                                )
                            }
                            onDrop={(e) => dropCheck(e, schema.type)}
                        />
                    )}
                    {(schema.type == "number" || schema.type == "integer" || type == "number") && (
                        <CurrencyInput
                            onFocus={this.fieldClicked}
                            maskOptions={null}
                            onBlur={(e) => this.onBlurCheck(e)}
                            onChange={(e) => this.onInputBoxChange("", e, schema.type)}
                            onKeyDown={(evt) => this.onInputBoxKeyDown(evt, schema.type)}
                            value={type == "number" ? (textValue === "undefined" ? "" : textValue) : textValue}
                            tabIndex={schema.const.tabIndex}
                            className="gaf-inputBox"
                            id={id}
                            type={schema.type == "integer" || schema.type == "number" ? "number" : type}
                            placeholder={schema.const && schema.const.placeholder && schema.const.placeholder}
                            // pattern="[0-9]"
                            // onKeyPress={e => { type === 'number' ? this.handleKeyPress(e, schema.type) : null }}
                            {...additionalProps}
                            onInput={(e) => this.validate(e, schema.type)}
                            autoComplete="off"
                            disabled={checkForReadOnly(schema.const, isSubmittedForm)}
                            onPaste={(e) =>
                                specialCharacterCheck(
                                    e,
                                    { value: e.target["value"], fieldName, family, errorSchema },
                                    schema.type
                                )
                            }
                            onDrop={(e) => dropCheck(e, schema.type)}
                        />
                    )}
                </div>
                <ErrorMessage errorDetails={errorDetails} errorState={error} propId={id} />
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    return {
        warrantyInfo: state.dynamicFormInfo.warrantyInfo,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        isSubmittedForm: state.adminData.isSubmittedForm,
        warrantyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
        warrantyId: state.dynamicFormInfo.warrantyId,
        isSubmitClicked: state.dynamicFormInfo.isSubmitClicked,
        waiverReceived: state.adminData.waiverReceived,
        clickDetails: state.dynamicFormInfo.clickDetails,
        userInfo: state.adminData.userInfo,
    };
}
export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalErrorActions: bindActionCreators(globalErrorActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InputTextBox);
